/**
 * Category → color mapping and UI palette.
 *
 * Palette (from the brief):
 *   attraction     #c0392b  red
 *   nature         #2f7d54  green
 *   transfer/hotel #262626  black
 *   accent         #1f7a8c  lake-teal (UI only, not a marker category)
 */

import type { Category } from './types';

export const CATEGORY_COLORS: Record<Category, string> = {
  attraction: '#c0392b',
  nature: '#2f7d54',
  transfer: '#262626',
  hotel: '#262626',
};

/** Lake-teal accent used across the UI (headers, active states). */
export const ACCENT = '#1f7a8c';

/** The marker color for a given category. */
export function categoryColor(category: Category): string {
  return CATEGORY_COLORS[category];
}

const CATEGORY_LABELS_HE: Record<Category, string> = {
  attraction: 'אטרקציה',
  nature: 'טבע',
  transfer: 'מעבר',
  hotel: 'לינה',
};

/** Short Hebrew label for a category (used in the legend and day list). */
export function categoryLabelHe(category: Category): string {
  return CATEGORY_LABELS_HE[category];
}
